import { Link } from "react-router-dom";
import React from "react";
export default function HomeFeatures({ data }) {
  return (
    <>
      <section className="featured-section space">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className={`wow animate__animated ${data?.animationWow}`} data-wow-delay={data?.delay} data-wow-duration={data?.duration}>
              <div className="featured-text">
                {data?.subtitle && <span className="subtitle">{data?.subtitle}</span>}
                {data?.heading && <h2 className="heading" dangerouslySetInnerHTML={{ __html: data?.heading }}></h2>}

                {data?.description && <p>{data?.description}</p>}
                {data?.buttonText && (
                  <div className="desktop-featureed-btn">
                    <div className="featured-btn ">
                      <Link to={data?.link || "#"} className="theme-btn">
                        <span>{data?.buttonText}</span>
                      </Link>
                    </div>
                  </div>
                )}
                 </div>
              </div>
            </div>
            <div className="col-md-6">
              {data?.image && (
                <div className="featured-img">
                <div className={`img-default ${data?.animate ? "img-animation" : ""}`}>
                    <img src={data?.image} alt={data?.imageAlt || "Featured Image"} className="img-responsive" loading="lazy"/>
                  </div>
                </div>
              )}

              {data?.buttonText && (
                <div className="mobile-featureed-btn">
                  <div className="featured-btn ">
                    <Link to={data?.link || "#"} className="theme-btn">
                      <span>{data?.buttonText}</span>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <div className="border-right"><span></span></div>

    </>
  );
}
